var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "gmap-map",
        {
          ref: "googlemapref",
          staticClass: "animation",
          style: "{width:100%; height:" + _vm.height + ";}",
          attrs: { zoom: 12, center: _vm.pickup_position, options: _vm.options }
        },
        [
          _c("gmap-marker", {
            attrs: {
              icon: _vm.pickup_icon,
              visible: _vm.renderPosition(_vm.pickup_position).lat !== "0",
              animation: 1,
              position: _vm.pickup_position,
              draggable: false
            }
          }),
          _vm._v(" "),
          _c("gmap-marker", {
            attrs: {
              icon: _vm.dropoff_icon,
              visible: _vm.renderPosition(_vm.dropoff_position).lat !== "0",
              animation: 1,
              position: _vm.dropoff_position,
              draggable: false
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }